const sectionStyle = {
  dNone: {
    display: "none!important",
  },
  dInline: {
    display: "inline!important",
  },
  dInlineBlock: {
    display: "inline-block!important",
  },
  dBlock: {
    display: "block!important",
  },
  dTable: {
    display: "table!important",
  },
  dTableRow: {
    display: "table-row!important",
  },
  dTableCell: {
    display: "table-cell!important",
  },
  dFlex: {
    display: "flex!important",
  },
  dInlineFlex: {
    display: "inline-flex!important",
  },
  flexRow: {
    flexDirection: "row!important",
  },
  flexColumn: {
    flexDirection: "column!important",
  },
  flexRowReverse: {
    flexDirection: "row-reverse!important",
  },
  flexColumnReverse: {
    flexDirection: "column-reverse!important",
  },
  flexWrap: {
    flexWrap: "wrap!important",
  },
  flexNowrap: {
    flexWrap: "nowrap!important",
  },
  flexWrapReverse: {
    flexWrap: "wrap-reverse!important",
  },
  justifyContentStart: {
    justifyContent: "flex-start!important",
  },
  justifyContentEnd: {
    justifyContent: "flex-end!important",
  },
  justifyContentCenter: {
    justifyContent: "center!important",
  },
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  justifyContentAround: {
    justifyContent: "space-around!important",
  },
  alignItemsStart: {
    alignItems: "flex-start!important",
  },
  alignItemsEnd: {
    alignItems: "flex-end!important",
  },
  alignItemsCenter: {
    alignItems: "center!important",
  },
  alignItemsBaseline: {
    alignItems: "baseline!important",
  },
  alignItemsStretch: {
    alignItems: "stretch!important",
  },
  alignSelfAuto: {
    alignSelf: "auto!important",
  },
  alignSelfStart: {
    alignSelf: "flex-start!important",
  },
  alignSelfEnd: {
    alignSelf: "flex-end!important",
  },
  alignSelfCenter: {
    alignSelf: "center!important",
  },
  alignSelfBaseline: {
    alignSelf: "baseline!important",
  },
  alignSelfStretch: {
    alignSelf: "stretch!important",
  },
  floatLeft: {
    float: "left!important",
  },
  floatRight: {
    float: "right!important",
  },
  floatNone: {
    float: "none!important",
  },
  positionStatic: {
    position: "static!important",
  },
  positionRelative: {
    position: "relative!important",
  },
  positionAbsolute: {
    position: "absolute!important",
  },
  positionFixed: {
    position: "fixed!important",
  },
  positionSticky: {
    position: "sticky!important",
  },
  fixedTop: {
    position: "fixed",
    top: "0",
    right: "0",
    left: "0",
    zIndex: "1030",
  },
  fixedBottom: {
    position: "fixed",
    right: "0",
    bottom: "0",
    left: "0",
    zIndex: "1030",
  },
  w25: {
    width: "25%!important",
  },
  w50: {
    width: "50%!important",
  },
  w75: {
    width: "75%!important",
  },
  w100: {
    width: "100%!important",
  },
  h25: {
    height: "25%!important",
  },
  h50: {
    height: "50%!important",
  },
  h75: {
    height: "75%!important",
  },
  h100: {
    height: "100%!important",
  },
  mw100: {
    maxWidth: "100%!important",
  },
  mh100: {
    maxHeight: "100%!important",
  },
  m0: {
    margin: "0!important",
  },
  mt0: {
    marginTop: "0!important",
  },
  my0: {
    marginTop: "0!important",
    marginBottom: "0!important",
  },
  mr0: {
    marginRight: "0!important",
  },
  mx0: {
    marginRight: "0!important",
    marginLeft: "0!important",
  },
  mb0: {
    marginBottom: "0!important",
  },
  ml0: {
    marginLeft: "0!important",
  },
  m1: {
    margin: "0.25rem!important",
  },
  mt1: {
    marginTop: "0.25rem!important",
  },
  my1: {
    marginTop: "0.25rem!important",
    marginBottom: "0.25rem!important",
  },
  mr1: {
    marginRight: "0.25rem!important",
  },
  mx1: {
    marginRight: "0.25rem!important",
    marginLeft: "0.25rem!important",
  },
  mb1: {
    marginBottom: "0.25rem!important",
  },
  ml1: {
    marginLeft: "0.25rem!important",
  },
  m2: {
    margin: "0.5rem!important",
  },
  mt2: {
    marginTop: "0.5rem!important",
  },
  my2: {
    marginTop: "0.5rem!important",
    marginBottom: "0.5rem!important",
  },
  mr2: {
    marginRight: "0.5rem!important",
  },
  mx2: {
    marginRight: "0.5rem!important",
    marginLeft: "0.5rem!important",
  },
  mb2: {
    marginBottom: "0.5rem!important",
  },
  ml2: {
    marginLeft: "0.5rem!important",
  },
  m3: {
    margin: "1rem!important",
  },
  mt3: {
    marginTop: "1rem!important",
  },
  my3: {
    marginTop: "1rem!important",
    marginBottom: "1rem!important",
  },
  mr3: {
    marginRight: "1rem!important",
  },
  mx3: {
    marginRight: "1rem!important",
    marginLeft: "1rem!important",
  },
  mb3: {
    marginBottom: "1rem!important",
  },
  ml3: {
    marginLeft: "1rem!important",
  },
  m4: {
    margin: "0.15rem!important",
  },
  mt4: {
    marginTop: "0.15rem!important",
  },
  my4: {
    marginTop: "0.15rem!important",
    marginBottom: "0.15rem!important",
  },
  mr4: {
    marginRight: "0.15rem!important",
  },
  mx4: {
    marginRight: "0.15rem!important",
    marginLeft: "0.15rem!important",
  },
  mb4: {
    marginBottom: "0.15rem!important",
  },
  ml4: {
    marginLeft: "0.15rem!important",
  },
  m5: {
    margin: "3rem!important",
  },
  mt5: {
    marginTop: "3rem!important",
  },
  my5: {
    marginTop: "3rem!important",
    marginBottom: "3rem!important",
  },
  mr5: {
    marginRight: "3rem!important",
  },
  mx5: {
    marginRight: "3rem!important",
    marginLeft: "3rem!important",
  },
  mb5: {
    marginBottom: "3rem!important",
  },
  ml5: {
    marginLeft: "3rem!important",
  },
  p0: {
    padding: "0!important",
  },
  pt0: {
    paddingTop: "0!important",
  },
  py0: {
    paddingTop: "0!important",
    paddingBottom: "0!important",
  },
  pr0: {
    paddingRight: "0!important",
  },
  px0: {
    paddingRight: "0!important",
    paddingLeft: "0!important",
  },
  pb0: {
    paddingBottom: "0!important",
  },
  pl0: {
    paddingLeft: "0!important",
  },
  p1: {
    padding: "0.25rem!important",
  },
  pt1: {
    paddingTop: "0.25rem!important",
  },
  py1: {
    paddingTop: "0.25rem!important",
    paddingBottom: "0.25rem!important",
  },
  pr1: {
    paddingRight: "0.25rem!important",
  },
  px1: {
    paddingRight: "0.25rem!important",
    paddingLeft: "0.25rem!important",
  },
  pb1: {
    paddingBottom: "0.25rem!important",
  },
  pl1: {
    paddingLeft: "0.25rem!important",
  },
  p2: {
    padding: "0.5rem!important",
  },
  pt2: {
    paddingTop: "0.5rem!important",
  },
  py2: {
    paddingTop: "0.5rem!important",
    paddingBottom: "0.5rem!important",
  },
  pr2: {
    paddingRight: "0.5rem!important",
  },
  px2: {
    paddingRight: "0.5rem!important",
    paddingLeft: "0.5rem!important",
  },
  pb2: {
    paddingBottom: "0.5rem!important",
  },
  pl2: {
    paddingLeft: "0.5rem!important",
  },
  p3: {
    padding: "1rem!important",
  },
  pt3: {
    paddingTop: "1rem!important",
  },
  py3: {
    paddingTop: "1rem!important",
    paddingBottom: "1rem!important",
  },
  pr3: {
    paddingRight: "1rem!important",
  },
  px3: {
    paddingRight: "1rem!important",
    paddingLeft: "1rem!important",
  },
  pb3: {
    paddingBottom: "1rem!important",
  },
  pl3: {
    paddingLeft: "1rem!important",
  },
  p4: {
    padding: "0.15rem!important",
  },
  pt4: {
    paddingTop: "0.15rem!important",
  },
  py4: {
    paddingTop: "0.15rem!important",
    paddingBottom: "0.15rem!important",
  },
  pr4: {
    paddingRight: "0.15rem!important",
  },
  px4: {
    paddingRight: "0.15rem!important",
    paddingLeft: "0.15rem!important",
  },
  pb4: {
    paddingBottom: "0.15rem!important",
  },
  pl4: {
    paddingLeft: "0.15rem!important",
  },
  p5: {
    padding: "3rem!important",
  },
  pt5: {
    paddingTop: "3rem!important",
  },
  py5: {
    paddingTop: "3rem!important",
    paddingBottom: "3rem!important",
  },
  pr5: {
    paddingRight: "3rem!important",
  },
  px5: {
    paddingRight: "3rem!important",
    paddingLeft: "3rem!important",
  },
  pb5: {
    paddingBottom: "3rem!important",
  },
  pl5: {
    paddingLeft: "3rem!important",
  },
  mAuto: {
    margin: "auto!important",
  },
  mtAuto: {
    marginTop: "auto!important",
  },
  myAuto: {
    marginTop: "auto!important",
    marginBottom: "auto!important",
  },
  mrAuto: {
    marginRight: "auto!important",
  },
  mxAuto: {
    marginRight: "auto!important",
    marginLeft: "auto!important",
  },
  mbAuto: {
    marginBottom: "auto!important",
  },
  mlAuto: {
    marginLeft: "auto!important",
  },
  textJustify: {
    textAlign: "justify!important",
  },
  textNowrap: {
    whiteSpace: "nowrap!important",
  },
  textTruncate: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  textLeft: {
    textAlign: "left!important",
  },
  textRight: {
    textAlign: "right!important",
  },
  textCenter: {
    textAlign: "center!important",
  },
  textLowercase: {
    textTransform: "lowercase!important",
  },
  textUppercase: {
    textTransform: "uppercase!important",
  },
  textCapitalize: {
    textTransform: "capitalize!important",
  },
  textWhite: {
    color: "#fff!important",
  },
  textBlack: {
    color: "#000!important",
  },
  visible: {
    visibility: "visible!important",
  },
  invisible: {
    visibility: "hidden!important",
  },
  opacity0: {
    opacity: "0",
  },
  border: {
    border: "1px solid #ddd!important",
  },
  borderTop: {
    borderTop: "1px solid #ddd!important",
  },
  borderRight: {
    borderRight: "1px solid #ddd!important",
  },
  borderBottom: {
    borderBottom: "1px solid #ddd!important",
  },
  borderLeft: {
    borderLeft: "1px solid #ddd!important",
  },
  border0: {
    border: "0!important",
  },
  borderTop0: {
    borderTop: "0!important",
  },
  borderRight0: {
    borderRight: "0!important",
  },
  borderBottom0: {
    borderBottom: "0!important",
  },
  borderLeft0: {
    borderLeft: "0!important",
  },
  borderDark: {
    borderColor: "#000!important",
  },
  borderWhite: {
    borderColor: "#fff!important",
  },
  bgLight: {
    backgroundColor: "#eee!important",
  },
  flexGrow: {
    flexGrow: "1"
  },
  bRounded: {
    borderRadius: "5px"
  },
  bCircle: {
    borderRadius: "1000px"
  },
};

export default sectionStyle;
